module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    ref: "copy_event_button",
    attrs: {
      "id": "vue-popper__copy_event_button"
    },
    on: {
      "click": _vm.openCopyEventDropdown
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + " "), _c('span', {
    staticClass: "icon-arrow-down5 marg-5-left"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fde6ab8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/CopyEventButton.vue
// module id = 2000
// module chunks = 1